export default {
  intercomData: (state) => {
    return { ...state.data }
  }
}
